import { payType } from '@/common';
import { getUserBankList } from '@/api/my';
export default {
  props: {
    list: {
      type: Array
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isFlilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectPayList: [],
      sleected: [],
      loading: false,
      isqrcode: false,
      onIcon: require('@/assets/image/ic_bank_on.png'),
      offIcon: require('@/assets/image/ic_bank_off.png'),
      payType: payType,
      qrcodeUrl: null,
      popupTitle: null
    };
  },
  created() {
    this.loading = true;
    //
    if (this.isFlilter) {
      this.getMyPayList();
    }
  },
  methods: {
    goAddAmount() {
      this.$router.push('/paymentReceiptInformation');
    },
    handleCode(item) {
      const {
        qrcode,
        paytype
      } = item;
      if (paytype != 'bank') {
        this.qrcodeUrl = qrcode;
        this.popupTitle = this.payType[paytype];
        this.isqrcode = true;
      }
    },
    getMyPayList() {
      this.loading = false;
      const userid = this.$store.getters['userInfo']?.id;
      getUserBankList({
        userid
      }).then(res => {
        const tab = res.data;
        let newTab = [];
        if (!this.isFlilter) {
          newTab = tab.filter(item => {
            return this.list?.some(item2 => item2.paytype === item.paytype);
          });
        } else {
          newTab = tab;
        }
        this.selectPayList = newTab;
      });
    },
    setSelectedList() {
      if (this.sleected.length > 0) {
        return this.sleected;
      }
      return null;
    },
    handleItem(item) {
      const {
        id
      } = item;
      if (this.isMultiple) {
        const existingIndex = this.sleected.findIndex(selectedItem => selectedItem.id === item.id);
        if (existingIndex === -1) {
          const samePaytypeIndex = this.sleected.findIndex(selectedItem => selectedItem.paytype === item.paytype);
          if (samePaytypeIndex !== -1) {
            this.sleected.splice(samePaytypeIndex, 1);
          }
          this.sleected.push(item);
        } else {
          this.sleected.splice(existingIndex, 1);
        }
      } else {
        this.sleected = [item];
      }
    }
  }
};